import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./yieldSummaryTable.module.scss";
import { formatItalianNumber } from "utils/formatUtils";

const YieldSummaryTable = ({ dataObject }) => {
  const { t } = useTranslation();
  if (!dataObject) {
    return null;
  }

  const rows = [
    {
      label: t("portfolio.distribuzioneProventi"),
      total: formatItalianNumber(dataObject.monthly_distribution),
      bonds: "-",
    },
    {
      label: t("portfolio.yieldToMaturity"),
      total: formatItalianNumber(dataObject.ytm_total),
      bonds: dataObject.ytm_obbligazioni || "0,00",
    },

    {
      label: t("portfolio.durationAnni"),
      total: formatItalianNumber(dataObject.duration_total),
      bonds: dataObject.duration_obbligazioni || "0,00",
    },
  ];

  return (
    <table className={styles.distribuzioneProventiTable}>
      <tbody>
        {rows.map((row, index) => (
          <tr key={index}>
            <td>{row.label}</td>
            <td>{row.total}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default YieldSummaryTable;
